import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'funds';

export function useGetAllFunds(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetFund(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateFund() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateFund({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteFund({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
